/**
 * @typedef {'pt' | 'en' | 'es'} SupportedLanguage
 */

/**
 * @typedef {Object} LanguageConfig
 * @property {SupportedLanguage} code
 * @property {string} flagPath
 * @property {string} flagAlt
 * @property {string} translationKey
 * @property {string} locale - Locale completo para formatação de números/datas
 */

export const DEFAULT_LANGUAGE = 'pt'

/** @type {Record<SupportedLanguage, LanguageConfig>} */
export const LANGUAGES = {
  pt: {
    code: 'pt',
    flagPath: '/flags/br.svg',
    flagAlt: 'Brasil',
    translationKey: 'languages.pt',
    locale: 'pt-BR'
  },
  en: {
    code: 'en',
    flagPath: '/flags/us.svg',
    flagAlt: 'United States',
    translationKey: 'languages.en',
    locale: 'en-US'
  },
  es: {
    code: 'es',
    flagPath: '/flags/es.svg',
    flagAlt: 'España',
    translationKey: 'languages.es',
    locale: 'es-ES'
  }
}

export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES)
